import React from 'react';
import CheckBox from '../../../element/checkbox';
import Title from '../../../element/title';
import clone from 'clone';
import url from '../../../urlhandler/urlHandlerActions';
import { findIndex } from 'underscore';

const $ = jQuery;
const RE = REBUILDER;
class CheckBoxPreview extends React.Component {
  constructor(props) {
    super(props);
    this.handleCheckBoxValue = this.handleCheckBoxValue.bind(this);
    this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
    this.state = {
      'values': [],
      'options': [],
      'toogle': false,
      showItem: 10,
    };
    this.filterable = API.filterable === 'true' ? true : false;
    this.changeToogle = this.changeToogle.bind(this);
    this.handleLoadMore = this.handleLoadMore.bind(this);
  }
  componentWillMount() {
    let defaultItem = null;
    const allLayout = clone(this.props.allLayout);
    const indexOfSearch = findIndex(allLayout, { type: 'search' });
    if (indexOfSearch !== -1) {
      const searchAttr = clone(allLayout[indexOfSearch].searchAttr);
      const indexOfCheckbox = findIndex(searchAttr, { viewType: 'checkbox' });
      if (indexOfCheckbox !== -1) {
        if (searchAttr[indexOfCheckbox].hasOwnProperty('showItem')) {
          defaultItem = parseInt(searchAttr[indexOfCheckbox]['showItem'], 10);
          this.setState({ defaultItem, showItem: defaultItem });
        } else {
          this.setState({ defaultItem });
        }
      }
    }
  }

  componentWillReceiveProps(nextprops) {
    let showItem = null;
    const allLayout = clone(nextprops.allLayout);
    const indexOfSearch = findIndex(allLayout, { type: 'search' });
    if (indexOfSearch !== -1) {
      const searchAttr = clone(allLayout[indexOfSearch].searchAttr);
      const indexOfCheckbox = findIndex(searchAttr, { viewType: 'checkbox' });
      if (indexOfCheckbox !== -1) {
        if (searchAttr[indexOfCheckbox].hasOwnProperty('showItem')) {
          showItem = parseInt(searchAttr[indexOfCheckbox]['showItem'], 10);
        }
      }
    }
    if (showItem !== this.state.defaultItem) {
      this.setState({ showItem });
    }
    this.setState({ toogle: nextprops.dropdonwtoggle[nextprops.block['uid']] });
    this.block = nextprops.block;
  }

  handleLoadMore(command) {
    switch (command) {
      case 'more':
        this.setState({ showItem: this.options.length });
        break;
      case 'less':
        let showItem = parseInt(this.state.showItem, 10);
        const allLayout = clone(this.props.allLayout);
        const indexOfSearch = findIndex(allLayout, { type: 'search' });
        if (indexOfSearch !== -1) {
          const searchAttr = clone(allLayout[indexOfSearch].searchAttr);
          const indexOfCheckbox = findIndex(searchAttr, { viewType: 'checkbox' });
          if (indexOfCheckbox !== -1) {
            if (searchAttr[indexOfCheckbox].hasOwnProperty('showItem')) {
              showItem = searchAttr[indexOfCheckbox]['showItem'];
            }
          }
        }
        this.setState({ showItem });
        break;
    }
  }
  handleCheckBoxValue(values) {
    this.setState({ 'values': _.pluck(values, 'slug') });
    url.push({
      'searchItem': this.searchItem, // keys
      'searchType': this.searchType, // taxonomies or metakeys
      'searchField': 'checkBox',
      values,
    });
  }
  changeToogle() {
    const toogle = !this.state.toogle;
    this.setState({ toogle });
  }
  render() {
    this.helperData = clone(this.props.helperData);
    this.block = this.props.block;
    let values = this.state.values;
    const urlData = this.props.urlData;
    if (urlData.hasOwnProperty('pagenumber')) {
      delete urlData['pagenumber'];
    }
    if (this.block.selectedDataType !== null) {
      // taxonomies
      if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
        const previousOptions = this.options;
        this.options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
        this.searchType = 'taxonomies';
        this.searchItem = this.block.selectedTaxonomy;
        const allUrlData = [];
        window.searchArray.map((item) => {
          if (item.key.toString() !== 'pagenumber' && item.key.toString() !== 'view') {
            allUrlData.push(item);
          }
        });
        const topKey = allUrlData.length !== 0 ? allUrlData[allUrlData.length - 1].key : null;
        let tempOptions = [];
        if (topKey !== null && this.filterable !== true) {
          let selectedOptions = [];
          const self = this;
          if (this.searchItem !== topKey) {
            // the searchItem is not the top
            if (urlData.hasOwnProperty(self.searchItem)) {
              if (!(_.isArray(urlData[self.searchItem]))) {
                selectedOptions.push(urlData[self.searchItem]); // previous selected Options
              } else {
                selectedOptions = clone(urlData[self.searchItem]);
              }
            }
            this.options.map((item) => {
              this.props.previewData.data.map((singleItem) => {
                const isAlreadyATakenOption = findIndex(tempOptions, { slug: item.slug });
                const optionIndex = _.indexOf(singleItem.terms[this.searchItem], item.slug);
                if ((optionIndex !== -1 && isAlreadyATakenOption === -1)) {
                  tempOptions.push(item);
                }
              });
              const selectedIndex = _.indexOf(selectedOptions, item.slug);
              if (selectedIndex !== -1) {
                const temp = [];
                temp.push(item);
                tempOptions = _.union(tempOptions, temp);
              }
            });
            this.options = clone(tempOptions);
          } else {
            if (Object.keys(urlData).length === 1) {
              this.options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
            }
            if (Object.keys(urlData).length !== 1) {
              if (previousOptions !== undefined) {
                this.options = clone(previousOptions);
              }
            }
          }
        }
      } else {
        this.options = this.props.helperData.metadata[this.block.selectedMetakey] ? this.helperData.metadata[this.block.selectedMetakey] : [];
        this.searchType = 'metakeys';
        this.searchItem = this.block.selectedMetakey;
      }

      // url case
      if (this.props.urlData.hasOwnProperty(this.searchItem)) {
        // if (this.state.values.length < 1) {
        values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
        // }
      } else {
        values = [];
      }
    }
    let showItem = this.state.showItem;
    const ifOpen = this.state.toogle ? 'active' : 'toggle-option';
    const HelperClass = this.state.toogle ? 'single-component' : '';
    const checkBoxClassName = this.props.block.dynamicNameClassCheckBox;
    let showLoadMore = true;
    let showLoadLessBlock = true;
    if (this.options.length <= showItem) {
      showItem = this.options.length;
      showLoadMore = false;
    }
    if (this.state.defaultItem > showItem) {
      showLoadLessBlock = false;
    }
    if (this.state.defaultItem === null) {
      showLoadMore = false;
      showLoadLessBlock = false;
      showItem = this.options.length;
    }
    if (this.block.LoadMoreOption === false || this.block.LoadMoreOption === 'false' || this.block.LoadMoreOption === undefined) {
      showLoadMore = false;
      showLoadLessBlock = false;
      showItem = this.options.length;
    }
    return (<div className={checkBoxClassName}>
        <Title
          title={this.props.block.title}
          subtitle={this.props.block.subtitle}
          toogle= {this.state.toogle}
          onToogle = {this.changeToogle}
          selectedToogleViewType = {'true'}
          dropdown={true}
          field={this.props.block.uid}
        />
        <div className={HelperClass + ' ' + 'dropdown-template'}>
        {this.options !== undefined && this.options.length ? <div>
        <CheckBox
          options={this.options}
          isOpenElement={ifOpen}
          setColumn={this.props.block.setColumn}
          showNumberOfItems={this.props.block.showNumberOfItems}
          searchItem={this.searchItem}
          previewData={this.props.previewData.data}
          value={values}
          onSelectCheckBox={this.handleCheckBoxValue}
          showItem={showItem}
          showLoadMore={showLoadMore}
          showLoadLessBlock={showLoadLessBlock}
          onHandleShowMore={this.handleLoadMore}
          block={this.block}
        />
      </div> : null}
      {this.options.length === 0 ?
        <div className="rq-no-attributes-found">
          <h3>{API.LANG.NO_ATTR_FOUND}</h3>
        </div> : ''}
      </div>
    </div>);
  }
}

CheckBoxPreview.propTypes = {
  'previewData': React.PropTypes.object,
  'urlData': React.PropTypes.object,
  'block': React.PropTypes.object,
  'helperData': React.PropTypes.object,
  'shortcodeKey': React.PropTypes.number,
};

export default CheckBoxPreview;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/search/dropdown/checkboxdropdownpreview.js
 **/